module.exports = "/static-assets/_next/static/images/santa-de1b39bbb9fa13fc1a5eff2d81ffadce.png";